enum PermissionType {
  CREATE = 'create',
  EDIT = 'edit',
  READ = 'read',
  SUBSCRIBE = 'subscribe',
  MARK_PUBLIC = 'mark_public'
}

enum PermissionEntityType {
  GOAL = 'GOAL',
  TASK = 'TASK',
  CONVERSATION = 'CONVERSATION',
  CHATBOT = 'CHATBOT',
  STRATEGY = 'STRATEGY',
  TASK_ASSIGNMENT = 'TASK_ASSIGNMENT',
  NODE__ASSIGNMENT = 'NODE__ASSIGNMENT'
}

interface PermissionModel {
  permissionType: PermissionType;
  entityType: PermissionEntityType;
  entityId: number | string;
}

export { PermissionEntityType, PermissionType };
export type { PermissionModel };
